import { MijnRoute } from '../../mijn-navigatie.model';

export const INCASSO_BATCHES_SUCCESS: MijnRoute = {
    path: 'succes',
    navigationEvent: 'toIncassobatchesSuccess',
    regex: /^\/incassobatches\/succes$/,
    webcomponent: 'mijn-incassobatches-webcomponent',
    internalPath: '/succes'
};
